/* eslint-disable max-statements */
/* eslint-disable max-len */
import {useMemo, useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {columnsPrices} from './table/columns';
import {hasAccessPermission} from '../../../common/permissions/validations';
import {resources, scopes} from '../../../common/permissions/dictionary';
import {Actions} from '../../../common/actions';
import './vehiclesPriceColor.scss';
import {paths} from '../../../common/dictionaries/urls';
import {pricesActions} from '../../constants';

const {
  clearActiveColorPrices,
  fetchActivePriceColor,
  fetchActiveProductions,
  navigateTo,
  addMessageBoxError,
} = Actions;


export const useVehiclesPriceColor = ({
  modalIsOpen,
  selectedVehicle,
  handleCloseModal,
}) => {
  const {masterCode, sfx} = selectedVehicle;
  const dispatch = useDispatch();
  const permissions = useSelector((state) => state.session.permissions);
  const {
    'activeColorsList': activeColorsListDB,
    'loadingPrices': loading,
    activeColorsEmpty,
    activeProductions,
  } = useSelector((state) => state.vehiclePriceColor);

  const [modalHistoryPriceWasOpen, setModalHistoryPriceWasOpen] = useState(false);
  const [updateDateMode, setUpdateDateMode] = useState(pricesActions.read);
  const [selectedProduction, setSelectedProduction] = useState(null);
  const [activeColorsListCurr, setActiveColorsListCurr] = useState([]);

  useEffect(() => {
    if (!hasAccessPermission(permissions, resources.VehiclesHistoryColor, scopes.See)) {
      dispatch(addMessageBoxError('Petición no procesada, usuario no cuenta con el permiso de visualización.'));
      dispatch(navigateTo(paths.VehiclesMaintenance));
    }
    return () => dispatch(clearActiveColorPrices());
  }, []);

  useEffect(() => {
    if (modalIsOpen) {
      dispatch(fetchActiveProductions(masterCode, sfx));
    }
  }, [modalIsOpen, selectedVehicle]);

  useEffect(() => {
    if (updateDateMode === pricesActions.read) {
      setActiveColorsListCurr(activeColorsListDB);
    }
  }, [updateDateMode]);

  useEffect(() => {
    if (activeProductions.length) {
      const startDate = activeProductions[0].startDate;
      let formattedDate = '';
      if (startDate) {
        const [month, year] = startDate.split('/');
        formattedDate = `${year}-${month}`;
      }
      const data = {
        'masterCode': masterCode,
        'sfx': sfx,
        'startDate': formattedDate,
      };
      setSelectedProduction(startDate || null);
      dispatch(fetchActivePriceColor(data));
    }
  }, [activeProductions]);

  useEffect(() => {
    if (selectedProduction) {
      const startDate = selectedProduction;
      let formattedDate = '';
      if (startDate) {
        const [month, year] = startDate.split('/');
        formattedDate = `${year}-${month}`;
      }
      const data = {
        'masterCode': masterCode,
        'sfx': sfx,
        'startDate': formattedDate,
      };
      dispatch(fetchActivePriceColor(data));
    }
  }, [selectedProduction]);

  useEffect(() => {
    if (activeColorsListDB.length) {
      setActiveColorsListCurr([...activeColorsListDB]);
    }
  }, [activeColorsListDB]);
  
  useEffect(() => {
    if (activeColorsEmpty.length) {
      setActiveColorsListCurr(activeColorsEmpty);
    }
  }, [activeColorsEmpty]);

  const onCloseModal = () => {
    setActiveColorsListCurr([]);
    dispatch(clearActiveColorPrices());
    handleCloseModal();
  };

  const updateMyData = (rowIndex, columnId, value) => {
    setActiveColorsListCurr((old) =>
      old.map((row, index) => {
        if (index === rowIndex) {
          setUpdateDateMode((oldDateMode) => {
            if (oldDateMode === pricesActions.editPrices || oldDateMode === pricesActions.read) {
              return pricesActions.editPrices;
            }
            return oldDateMode;
          });
          const updatedRow = {
            ...old[rowIndex],
            [columnId]: value || '',
          };
          if (columnId === 'commission' || columnId === 'colorValue' ||
            columnId === 'shippingCost' || columnId === 'fob') {
            return {
              ...updatedRow,
              'cif': (typeof updatedRow.fob === 'string' ? Number(updatedRow.fob?.replace(',', '.') || 0) : updatedRow.fob) +
                (typeof updatedRow.shippingCost === 'string' ? Number(updatedRow.shippingCost?.replace(',', '.') || 0) : updatedRow.shippingCost) +
                (typeof updatedRow.colorValue === 'string' ? Number(updatedRow.colorValue?.replace(',', '.') || 0) : updatedRow.colorValue) +
                (typeof updatedRow.commission === 'string' ? Number(updatedRow.commission?.replace(',', '.') || 0) : updatedRow.commission),
            };
          }
        }
        return row;
      })
    );
  };

  const data = useMemo(() => activeColorsListCurr, [activeColorsListCurr]);
  const columns = useMemo(() => columnsPrices(), [activeColorsListDB]);

  const modelInfoProps = {
    updateDateMode,
    selectedProduction,
    setSelectedProduction,
    setActiveColorsListCurr,
    activeColorsListDB,
    'loadingPrices': loading,
    'setUpdateMode': setUpdateDateMode,
    'selectedVehicle': selectedVehicle,
    'openHistoryPriceModal': () => setModalHistoryPriceWasOpen(true),
    'activeColorsList': activeColorsListCurr,
  };

  return {
    'actions': {
      onCloseModal,
      setModalHistoryPriceWasOpen,
      selectedProduction,
      updateMyData,
    },
    'data': {
      modelInfoProps,
      loading,
      modalHistoryPriceWasOpen,
      data,
      columns,
    },
  };
};
